export default __webpack_public_path__ + "static/media/logo.b076cf2d.svg";